export const tablet = "@media only screen and (max-width: 968px)";
